import React, { Component } from 'react';
import Translation from '@showclix-shared/CheckoutProcess/components/Translation';
import Button from '@s/Button';
import { setCheckoutOverlay } from '@/actions/ui';
import { updateDisplayedItems } from '@/actions/continueShoppingModal';
import FocusTrap from '@s/FocusTrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getMainEvent, getSelectedEvent } from '@/selectors/event';
import { getEventTimeFormatted } from '@v/series/selectors/eventSeries';
import { getEventDate } from '@h/helpers'
import { withRouterCompat } from '@h/withRouterCompat';

class ContinueShoppingModal extends Component {

  state = {
    ticketsToDisplay: [],
  }

  componentDidMount() {
    // store the tickets to display in local state
    this.setState({ticketsToDisplay: this.props.tickets.filter(ticket => !this.props.displayedTicketIds.includes(+ticket.id))});
    // then store that they have been displayed
    this.props.updateDisplayedItems();
  }

  onContinueHandler = () => {
    const page = this.props.isSeries && !this.props.isDynamic ? "/day" : "/";
    this.props.navigate(page);
    this.props.setCheckoutOverlay(false);
  };

  onCheckoutHandler = () => {
    this.props.navigate(`/checkout/${this.props.token}`);
  };

  getDateString = () => {
    if (!this.props.selectedEventStart) return undefined;
    return getEventDate(this.props.selectedEventStart, this.props.selectedEventEnd, this.props.locale);
  }

  groupItems() {
    return this.state.ticketsToDisplay.reduce((acc, ticket) => {
      const pl_name = ticket.price_level_name ? ticket.price_level_name : '';
      if (!acc[ticket.price_level_id]) {
        acc[ticket.price_level_id] = {
          name: pl_name,
          count: 1
        };
      } else {
        acc[ticket.price_level_id].count++;
      }
      return acc;
    }, {});
  }

  render() {
    const dateString = this.getDateString();
    const groupedItems = this.groupItems();

    return (
      <FocusTrap fallback=".continue-shopping-wrap">
        <div className="continue-shopping-wrap" aria-modal="true" tabIndex="-1">
          <div className="continue-shopping-modal__header">
          <span className="continue-shopping-modal__title">
            <i className="icon-shopping_cart continue-shopping-cart-icon" />
            <Translation>{'checkout__added_to_cart'}</Translation>
          </span>
          </div>
          <div className="continue-shopping-modal__content">
            {!!this.props.eventName && <div className="continue-shopping-modal__event-info">
              <span className="continue-shopping-modal__event">{this.props.eventName}</span>
              <br/>
              <div className="continue-shopping-modal__event-date">
                {dateString || ''}
              </div>
            </div>}
            {
              Object.values(groupedItems).map((group, idx) => (
                <div
                  key={`carted-item-${idx}`}
                  className="continue-shopping-modal__item-row"
                >
                  <span className="continue-shopping-modal__item-qty">{group.count}x</span>
                  <span className="continue-shopping-modal__item">
                  {group.name}
                </span>
                </div>
              ))
            }

          </div>
          <div className="continue-shopping-modal__footer">
            <Button
              onClick={this.onContinueHandler}
            >
              <Translation>{'checkout__add_more_tickets'}</Translation>
            </Button>
            <Button
              onClick={this.onCheckoutHandler}
              className="button--primary"
            >
              <Translation>{'checkout__checkout'}</Translation>
            </Button>
          </div>
        </div>
      </FocusTrap>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.reservation.token,
    eventName: state.ui.listingConfig?.listings?.title ?? null,
    locale: state.intl.locale,
    isSeries: !!getMainEvent(state)?.event?.isRecurring,
    getEventTimeFormatted: getEventTimeFormatted(state),
    selectedEventStart: getSelectedEvent(state)?.event?.start,
    selectedEventEnd: getSelectedEvent(state)?.event?.end,
    tickets: state.tickets.tickets,
    displayedTicketIds: state.continueShoppingModal.displayedTicketIds,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    setCheckoutOverlay,
    updateDisplayedItems,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouterCompat(ContinueShoppingModal));
